import { prefix } from './actions';

export const loading = state => state[prefix].loading;
export const materialsModalOpened = state => state[prefix].materialsModalOpened;

export const listAdmin = state => state[prefix].listAdmin;
export const itemAdmin = state => state[prefix].itemAdmin;
export const saving = state => state[prefix].saving;
